
<ng-container>
  <div class="col-12 section-title"> <h1>Congratulations</h1></div><p></p>
  <div class="col-12">  <p class="lead">Your test application is now complete! In a real application submission, you will receive an on-screen message confirming the underwriting journey the policy will follow — as well as a follow-up email containing the same information. Cases submitted through the John Hancock eApp will be considered for John Hancock ExpressTrack® or go through traditional underwriting.
  </p></div>
    <div class="col-12"> 
      <h2><br><b>ExpressTrack underwriting: </b> <br></h2>
      <p class="lead">
        Proposed insureds ages 18-60 applying for face amounts up to and including $3 million will be considered for ExpressTrack — our accelerated, non-invasive underwriting approach. 
      </p>
        <ul class="lead  jh-font-family">
      <li class="lead jh-font-family">
        Some submissions that qualify for ExpressTrack will receive an <b>instant underwriting decision</b>
      </li>
      <li class="lead jh-font-family">
        Other submissions that qualify ExpressTrack may require a <b>brief underwriting review</b>, which simply means that the case may still qualify for a non-invasive process, but the underwriter may need to ask for additional clarifying details, e.g., additional financial details   
      </li>
    </ul>
  
  </div>
  <div class="col-12"> 
    <h2><br><b>Traditional underwriting: </b> <br></h2>
    <p class="lead">Proposed insureds who do not qualify for ExpressTrack, are ages 61+ or applying for greater than $3 million, will continue to traditional underwriting, meaning John Hancock underwriters will review the application and questionnaires that were submitted and post any additional requirements (e.g., an Attending Physician statement) that may be needed for the underwriting assessment.
    </p>
</div>
<br/>
<br/>
<br/>


  <div class="mp-btn-container">
    <div style="margin-top: 50px" class="btn-container-full-width-even-space">
      <button (click)="startDemoApplication()" class="btn-secondary mp-btn-small" style="width: 300px; height: 50px; padding: 0; margin-right:20px; min-width: 250px;">Start a new test application</button>


      <button (click)="backToMiniPortal()" class="btn-primary mp-btn-small" style="width: 300px; height: 50px; padding: 0; margin-left:20px; min-width: 250px;">Go to the Portal to get started</button>
    </div>
  </div>
</ng-container>
<!-- /field -->
  <!-- spinner -->
  <div class="spinner-wrapper text-center" [ngClass]="{'show': processing}">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div><!-- /spinner -->
